import * as React from "react";

import { AppLabel, AppLabelProps } from "@1js/acui-label";

export class RibbonLabel extends React.PureComponent<AppLabelProps, {}> {
  public render() {
    return <AppLabel {...this.props} />;
  }
}
